export default {
  title: 'Pausar Disponibilidade',
  description: 'Esgotado?',
  pause_availabilities: {
    pause_until_end_of_day: 'Pausar reservas até ao fim do dia?',
    pause_specific_time: 'Pausar reservas para um dia e/ou hora diferentes',
  },
  pause_reservations_today: 'Pausar Reservas Hoje',
  pause_reservations_another_day: 'Pausar Reservas para Outro Dia',
  paused_availabilities_form: {
    date_time: {
      label: 'Selecionar uma Data e hora',
    },
    reason: {
      label: 'Adicionar um motivo (opcional)',
      placeholder: 'Inserir descrição...',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  error_messages: {
    creation_failed: 'Falha ao criar exceção',
  },
};
